import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SPORTS } from '../utils/constants';
import './Navbar.css';

function Navbar() {
  const { user, profile, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [navCity, setNavCity] = useState('');
  const [navSport, setNavSport] = useState('');
  const navigate = useNavigate();

  const handleNavSearch = async (e) => {
    e.preventDefault();
    let cityValue = navCity.trim();

    if (/^\d{5}$/.test(cityValue)) {
      try {
        const res = await fetch(`https://api.zippopotam.us/us/${cityValue}`);
        if (res.ok) {
          const data = await res.json();
          cityValue = data.places[0]['place name'];
        }
      } catch (err) {
        console.warn('Zip lookup failed, searching as-is:', err);
      }
    }

    const params = new URLSearchParams();
    if (cityValue) params.set('city', cityValue);
    if (navSport) params.set('sport', navSport);
    navigate(`/mentors?${params.toString()}`);
  };

  const handleSignOut = async () => {
    closeMenu();
    // Use the context signOut — it clears local state immediately THEN
    // fires the network call with a timeout, so the UI reacts instantly
    // even on a bad mobile connection.
    await signOut();
    window.location.href = '/';
  };

  const closeMenu = () => setMenuOpen(false);

  const isMentor = profile?.role === 'mentor';
  const isAdmin = profile?.is_admin === true;

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src="/gameplan.icon.svg" alt="GamePlannr" className="nav-logo-img" />
          <div className="nav-logo-text">
            <span className="nav-wordmark"><em>Game</em>plannr</span>
            <span className="nav-tagline">Young Trainers. Real Skills.</span>
          </div>
        </Link>

        <form className="nav-search-bar" onSubmit={handleNavSearch}>
          <input
            type="text"
            className="nav-search-city"
            placeholder="🔍  City or zip code..."
            value={navCity}
            onChange={(e) => setNavCity(e.target.value)}
          />
          <div className="nav-search-sep" />
          <select
            className="nav-search-sport"
            value={navSport}
            onChange={(e) => setNavSport(e.target.value)}
          >
            <option value="">All Sports</option>
            {SPORTS.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
          <div className="nav-search-sep" />
          <button type="submit" className="nav-search-btn">Search</button>
        </form>

        <button
          className={`navbar-hamburger${menuOpen ? ' open' : ''}`}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`navbar-links${menuOpen ? ' open' : ''}`}>
          <NavLink to="/mentors" className="nav-link" onClick={closeMenu}>
            Find Trainers
          </NavLink>

          {!user && (
            <>
              <NavLink to="/signup" className="nav-link-signup" onClick={closeMenu}>
                Sign Up
              </NavLink>
              <NavLink to="/signin" className="nav-link" onClick={closeMenu}>
                Sign In
              </NavLink>
            </>
          )}

          {user && (
            <>
              {isAdmin && (
                <Link to="/admin" className="nav-link" onClick={closeMenu}>Admin</Link>
              )}
              {isAdmin ? (
                <Link to="/dashboard" className="nav-link" onClick={closeMenu}>My Dashboard</Link>
              ) : (
                <Link
                  to={isMentor ? '/mentor-dashboard' : '/dashboard'}
                  className="nav-link"
                  onClick={closeMenu}
                >
                  {isMentor ? 'My Dashboard' : 'Dashboard'}
                </Link>
              )}
              <NavLink to="/profile" className="nav-link" onClick={closeMenu}>
                Profile
              </NavLink>
              <button className="nav-link-signout" onClick={handleSignOut}>
                Sign Out
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
